import TiclickTable from '@src/design-system/molecules/ticlick-table';
import { PageContainer } from '@src/shared/components/page-container';
import { PageTitle } from '@src/shared/components/page-title';
import { useHostCompaniesTable } from '../../hooks/use-host-companies-table';

export const HostCompaniesPage = () => {
  const { table, actionsTable } = useHostCompaniesTable();
  return (
    <PageContainer>
      <div className='flex items-center gap-2.5'>
        <PageTitle titles={['Host Companies']} />
      </div>
      <div className='p-4 rounded-lg border bg-white border-pale-border [&_td]:text-gray-900 [&_th]:text-gray-800 [&_th]:h-12 [&_th]:font-bold [&_th]:text-sm'>
        <TiclickTable
          table={table}
          actions={actionsTable}
        />
      </div>
    </PageContainer>
  );
};
